import { Container } from 'pixi.js';

/**
 * Base class for all game scenes.
 */
export class BaseScene {
  constructor(sceneManager, eventBus) {
    this.sceneManager = sceneManager;
    this.eventBus = eventBus;
    this.container = new Container();
  }

  /** Called once when scene becomes active */
  init() {}

  /** Called every frame */
  update(dt) {}

  /** Called when scene is replaced */
  destroy() {}
}
